import * as R from 'ramda'
import { API_CONST } from '../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])

const attachLoginActions = generateActions('login/attach')
const requestCodeActions = generateActions('login/code/request')
const confirmCodeActions = generateActions('login/code/confirm')

// ------------------------ //

export const requestCode = createAction(API_CONST, userLoginId => ({
  actions: requestCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const confirmCode = createAction(API_CONST, (userLoginId, codeValue) => ({
  method: 'post',
  params: { codeValue },
  actions: confirmCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const attachLogin = createAction(
  API_CONST,
  login => ({
    method: 'POST',
    params: { login },
    url: 'auth/info/settings/attachLogin',
    actions: attachLoginActions
  })
)

export const clearAuthData = createAction('login/CLEAR_DATA')

// ------------------------ //

const initial = {
  state: 'init',
  loginId: null,
  error: null
}

export default handleActions({
  [confirmCodeActions[0]]: (state, { payload }) => ({ ...state, error: null }),
  [confirmCodeActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [requestCodeActions[0]]: (state, { payload }) => ({ ...state, error: null }),
  [requestCodeActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [attachLoginActions[0]]: (state, { payload }) => ({ ...state, error: null }),
  [attachLoginActions[1]]: (state, { payload }) => {
    const enabled = R.pathOr(false, [ 'is', 'enabled' ], payload)

    return ({
      ...state,
      error: null,
      loginId: payload._id,
      state: enabled ? 'success' : 'confirm'
    })
  },
  [attachLoginActions[2]]: (state, { payload }) => ({
    ...state,
    loginId: null,
    error: payload.message.response.data.error
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/login.js